export const urlConstructor = (external_id, filename, type) => {
  const urlMap = {
    image: `https://cerifi.widen.net/content/${external_id}/jpeg/${filename}`,
    video: `https://cerifi.widen.net/view/video/${external_id}/${filename}`,
    audio: `https://cerifi.widen.net/content/${external_id}/mp3/${filename}`,
    document: `https://cerifi.widen.net/view/pdf/${external_id}/${filename}`,
    file: `https://cerifi.widen.net/content/${external_id}/original/${filename}`
  };
  return type in urlMap ? urlMap[type] : (console.error('File not supported'), undefined);
};